import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import {
	CreditBureauEmployment,
	VerificationMethod,
	Country,
	MexState
} from '@/graphql/__generated__/onboarding';
import { getVerificationMethodText, getMexStateText, getCountryText } from './mapUtils';
import ExpandableTable from './ExpandableTable';

interface EmploymentsProps {
	employments?: CreditBureauEmployment[] | null;
}

const Employments: React.FC<EmploymentsProps> = ({ employments }) => {
	const t = useTranslations('CreditBureau');
	const stateT = useTranslations('States');
	const countryT = useTranslations('Countries');

	if (!employments || employments.length === 0) return null;

	// Create new objects with translated keys and mapped values
	const translatedData = employments.map((employment) => {
		return Object.entries(employment)
			.filter(([key]) => key !== '__typename')
			.reduce(
				(acc, [key, value]) => {
					const translatedKey = t(toTranslationKey(key));

					// Map special fields
					if (key === 'verificationMethod' && value) {
						acc[translatedKey] = getVerificationMethodText(value as VerificationMethod, t);
					} else if (key === 'countryCode' && value) {
						acc[translatedKey] = getCountryText(value as Country, countryT);
					} else if (key === 'stateCode' && value) {
						acc[translatedKey] = getMexStateText(value as MexState, stateT);
					} else {
						acc[translatedKey] = value;
					}

					return acc;
				},
				{} as Record<string, any>
			);
	});

	return (
		<ExpandableTable title={t('Employments')}>
			<div className="max-w-4xl">
				<FlexibleTable data={translatedData} />
			</div>
		</ExpandableTable>
	);
};

export default Employments;
